import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "alm-react-components";
import { useState } from "react";

export const PopOverTitle = ({ text, component }: any) => {
  const [open, setOpen] = useState<any>(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };
  return (
    <Popover open={open}>
      <PopoverTrigger
        onMouseEnter={() => handleMouseEnter()}
        onMouseLeave={() => handleMouseLeave()}
      >
        {component}
      </PopoverTrigger>
      <PopoverContent
        onMouseEnter={() => handleMouseEnter()}
        onMouseLeave={() => handleMouseLeave()}
        className="w-60"
      >
        <div className="space-y-2">
          <p className="font-medium leading-none">{text}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
